import { gql } from "@apollo/client";

export const USERS = gql`
  query Users($filters: UserListFilters, $page: Int!) {
    Users(filters: $filters, page: $page) {
      users {
        _id
        email
        name
        cpf
        cnpj
        phone
        status
        plan
        business_id
        partner_company {
          name
        }
      }
      pages
      currentPage
      total
    }
  }
`;

export const USER = gql`
query User($id: String!) {
  User(uid: $id) {
    email
    name
    cpf
    phone
    status
    plan
    iugu_customer_id
    iugu_subscription_id
    plan
    notes
    partner_id
    partner_name
    gov_br_password
    certificate_used
    certificate_duedate
    certificate_url
    certificate_password
    contract_status
  }
}
`;

export const USER_SAVE = gql`
mutation User($input:UserInput!) {
  User(input:$input) {
    _id
    email
    name
    cpf
    phone
    status
    plan
    updatedAt
    createdAt
    iugu_customer_id
    iugu_subscription_id
    plan
    partner_id
    partner_name
    gov_br_password
  }
}
`;

export const BUSINESS = gql`
  query Business($id: String!, $business_id: String!) {
    Business(uid: $id, business_id: $business_id) {
      cnpj
      company_name
      trade_name
      email
      access_code
      municipal_registration
      state_registration
      inactivation_date
      status
      external_password
      city_login
      city_password
      certificate_used
      certificate_duedate
      ctn
      nire
      ancord_enabled
      activity_start
      register_date
    }
  }
`;

export const BUSINESS_SAVE = gql`
mutation Business($input: BusinessInput!, $uid: String, $business_id: String) {
  Business(uid: $uid, input: $input, business_id: $business_id) {
    _id
  }
}
`;

export const ADDRESS = gql`
query AddressByUser($id: String!, $business_id: String!) {
  AddressByUser(id: $id, business_id: $business_id) {
    addressable_type
    street
    zip_code
    number
    complement
    neighborhood
    city
    state
    municipal_code
  }
}
`;

export const ADDRESS_SAVE = gql`
mutation AddressByUser($input: AddressInput!, $id: String!, $business_id: String!) {
  AddressByUser(input: $input, id:$id, business_id: $business_id) {
    _id
  }
}
`;

export const CONTRACT = gql`
query Contract($uid: String!, $business_id: String!) {
  Contract(uid: $uid, business_id:$business_id) {
    responsibility_start
    signature_date
  }
}
`;

export const CONTRACT_SAVE = gql`
mutation Contract($uid: String!, $input: ContractInput!, $business_id: String!) {
  Contract(uid: $uid, input: $input, business_id:$business_id) {
    responsibility_start
    signature_date
  }
}
`;

export const DOCUMENTS = gql`
query Business($id: String!, $business_id: String!) {
  Business(uid: $id, business_id: $business_id) {
    documents {
        alvara {
            _id
            name
            path
        }
        cartao_cnpj {
            _id
            name
            path
        }
        certificado_mei {
            _id
            name
            path
        }
        rg {
            _id
            name
            path
        }
        cpf {
            _id
            name
            path
        }
        cnh {
            _id
            name
            path
        }
        titulo_eleitor {
            _id
            name
            path
        }
        iptu {
            _id
            name
            path
        }
        social_contract {
            _id
            name
            path
        }
        certificado {
            _id
            name
            path
        }
    }
  }
}
`;

export const DOCUMENT_DELETE = gql`
mutation BusinessDocumentDelete($document_id: String!, $uid: String!, $business_id: String!, $document_type: String!) {
    BusinessDocumentDelete(document_id: $document_id, uid: $uid, business_id: $business_id, document_type: $document_type)
}
`;

export const DOCUMENT_UPLOAD = gql`
mutation BusinessDocument($input: BusinessDocumentInput!, $uid: String!, $business_id: String!) {
  BusinessDocument(input: $input, uid: $uid, business_id: $business_id) {
      _id
      name
      path
      type
      key
  }
}
`;

export const DOCUMENT_UPLOAD_DYNAMIC = gql`
mutation BusinessDocumentDynamicUpload($input: [BusinessDocumentDynamicInput!]!, $uid: String!, $business_id: String!) {
      BusinessDocumentDynamicUpload(input:$input, uid: $uid, business_id: $business_id)
}
`;

export const DOCUMENT_DELETE_DYNAMIC = gql`
mutation BusinessDocumentDynamicDelete($document_id: String!, $uid: String!, $documentType: String!, $business_id: String!) {
      BusinessDocumentDynamicDelete(uid: $uid, document_id: $document_id, documentType: $documentType, business_id: $business_id)
}
`;

export const DOCUMENTS_DYNAMIC = gql`
query BusinessDocumentsDynamic($documentType: String!, $uid: String!, $business_id: String!) {
      BusinessDocumentsDynamic(documentType:$documentType, uid: $uid, business_id: $business_id) {
        ... on BusinessDocumentDynamic {
          name
          key
          mimetype
          _id
        }
        ... on BusinessGuide {
          _id
          name
          key
          mimetype
          status
          paymentDate
          createdAt
          dueDate
          receiptKey
          fees
          fine
          subtotal
          total
          readAt
          type
        }
       
      }
}
`;

export const CREATE_USER = gql`
mutation CreateUser($input:CreateUserInput!) {
  CreateUser(input:$input) {
    result
    error
  }
}
`;

export const USER_DOCUMENTS = gql`
query UserDocuments($id: String!) {
  UserDocuments(uid: $id) {
    mother_name
    rg
    birth_date
    voter_title
    tax_code
  }
}
`;

export const USER_DOCUMENTS_SAVE = gql`
mutation UserDocuments($input: CreateUserDocuments!, $uid: String!) {
  UserDocuments(input: $input, uid: $uid) {
    mother_name
    rg
    birth_date
    voter_title
    tax_code
  }
}
`;

export const USER_RESET_PASSWORD = gql`
mutation UserResetPassword($id: String!) {
  UserResetPassword(id: $id)
}
`;

export const USER_WELCOME_EMAIL = gql`
mutation UserResendWelcomeEmail($id: String!) {
  UserResendWelcomeEmail(id: $id)
}
`;

export const LOGS_SAVE = gql`
mutation UsersLog($input: UserLogInput!) {
  UsersLog(input: $input)
}
`;

export const LOGS_GET = gql`
query UsersLogs($id: String!) {
  UsersLogs(id: $id) {
    content
    createdAt
    userName
    author
  }
}
`;

export const USER_IMPORT = gql`
  mutation UserImport($file: Upload!, $partner: String) {
    UserImport(file: $file, partner: $partner) {
      result
      error
      notCreated
    }
  }
`;

export const USER_REMOVE = gql`
  mutation UserRemove($id: String!) {
    UserRemove(id: $id)
  }
`;


export const USER_BUSINESSES = gql`
  query UserBusinesses($uid: String!) {
    UserBusinesses(uid: $uid) {
      _id
      company_name
      trade_name
    }
  }
`;


export const ADD_BUSINESS = gql`
mutation AddBusiness($input:CreateUserInput!, $uid: String!) {
  AddBusiness(input:$input, uid:$uid) {
    result
    error
  }
}
`;
